import {
  LEGAL_EXEMPTION_REASON,
  isNilOrEmpty,
} from "@tastyworks/tastyworks-api"
import { array, object, string, type InferType } from "yup"

export const LEGAL_EXEMPTION_NONE = "NONE" as const

const businessAffiliationOptionValues = [
  "hasForeignInstitutionAffiliation",
  "hasForeignBankAffiliation",
] as const

export type BusinessAffiliationOptions = Array<
  (typeof businessAffiliationOptionValues)[number]
>

export const businessAffiliationsSelectSchema = object({
  hasNoBusinessAffiliations: string().oneOf(["true", undefined]),
  businessAffiliations: array()
    .ensure()
    .of(string().oneOf(businessAffiliationOptionValues).required())
    .test(
      "selectsNoneOrSome",
      "yup.common.mixed.required",
      (value, { parent }) => {
        if (parent?.hasNoBusinessAffiliations === "true")
          return isNilOrEmpty(value)
        return !isNilOrEmpty(value)
      }
    ),
})

export const foreignInstitutionNameSchema = object({
  foreignInstitution: string().required(),
})

export const legalExemptionSchema = object({
  legalExemptionReason: string()
    .required()
    .oneOf([...Object.values(LEGAL_EXEMPTION_REASON), LEGAL_EXEMPTION_NONE]),
})

export type LegalExemptionData = InferType<typeof legalExemptionSchema>

export const businessAffiliationSchema = object({
  businessAffiliationsSelect: businessAffiliationsSelectSchema,
  foreignInstitutionName: foreignInstitutionNameSchema,
  legalExemption: legalExemptionSchema,
})
